import {
  PrivateBlogEntity,
} from './privateBlogEntity';
import { Abstract } from './valueObjects/abstract';
import { Category } from './valueObjects/category';
import { CreateDatetime } from './valueObjects/createDatetime';
import { LastModifiedDatetime } from './valueObjects/lastModifiedDatetime';
import { MemberId } from './valueObjects/memberId';
import { PublishDatetime } from './valueObjects/publishDatetime';
import { Title } from './valueObjects/title';

import type {
  PrivateBlogProps,
} from './privateBlogEntity';
import type { PrivateBlogJson } from '@/types/domain/privateBlog/entities/privateBlogEntity';

import { Factory } from '@/domain/factory';

export class PrivateBlogFactory extends Factory<
  PrivateBlogEntity,
  PrivateBlogProps,
  PrivateBlogJson
> {
  /**
   * 比較
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePvt = (a: PrivateBlogJson, b: PrivateBlogJson) => {
    const da = new Date(a.publishDatetime);
    const db = new Date(b.publishDatetime);
    return da < db ? 1 : -1;
  };

  /**
   * Entityを生成する
   * @param props プロパティ
   * @returns Entity
   */
  createPvt(props: PrivateBlogProps): PrivateBlogEntity {
    return new PrivateBlogEntity(props, null);
  }

  /**
   * JsonからEntityを生成する
   * @param props Json
   * @returns Entity
   */
  createFromJsonPvt(props: PrivateBlogJson): PrivateBlogEntity {
    return this.createPvt({
      createDatetime: CreateDatetime.create(new Date(props.createDatetime)),
      createMemberId: MemberId.create(props.createMemberId),
      lastModifiedDatetime: LastModifiedDatetime.create(new Date(props.lastModifiedDatetime)),
      lastModifiedMemberId: MemberId.create(props.lastModifiedMemberId),
      publishDatetime: PublishDatetime.create(new Date(props.publishDatetime)),
      publishMemberId: MemberId.create(props.publishMemberId),
      title: Title.create(props.title),
      categoryId: Category.create(props.categoryId),
      abstract: Abstract.create(props.abstract || ''),
      numOfImg: props.numOfImg,
    });
  }
}
